module.exports = __webpack_public_path__ + "img/myposition_am.43e2fe5c.svg";